import React, { useEffect } from 'react';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
//import './tiptap.css'; // optional: eigenes Styling

const TiptapEditor = ({ content, onChange }) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Link.configure({
        openOnClick: false
      })
    ],
    content,
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    }
  });

  useEffect(() => {
    if (editor && content !== editor.getHTML()) {
      editor.commands.setContent(content || '');
    }
  }, [content, editor]);

  if (!editor) return null;

  return (
    <div className="border rounded p-2 bg-white dark:bg-base-100">
      <div className="flex flex-wrap gap-2 mb-2">
        <button onClick={() => editor.chain().focus().toggleBold().run()} className="btn btn-sm">
          Bold
        </button>
        <button onClick={() => editor.chain().focus().toggleItalic().run()} className="btn btn-sm">
          Italic
        </button>
        <button onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()} className="btn btn-sm">
          H1
        </button>
        <button onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} className="btn btn-sm">
          H2
        </button>
        <button onClick={() => editor.chain().focus().toggleBulletList().run()} className="btn btn-sm">
          • List
        </button>
        <button onClick={() => editor.chain().focus().toggleOrderedList().run()} className="btn btn-sm">
          1. List
        </button>
        <button onClick={() => {
          const url = prompt('URL einfügen');
          if (url) {
            editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
          }
        }} className="btn btn-sm">
          🔗 Link
        </button>
      </div>

      <EditorContent editor={editor} />
    </div>
  );
};

export default TiptapEditor;
